import React, { useState, useRef, useEffect } from 'react';

// @ts-ignore
import { useWavesurfer } from '@wavesurfer/react'

import { useAppSelector } from "../../../redux/hooks";
import { selectAccountSettings } from "../../../redux/store";

import { MessageAudioPlayerProps } from "./props";
import useStyles from "./css";
import { Color } from "../../../constants/colors";
import { WhatsAppAudioLogo, WhatsAppMicrophoneIcon, WhatsAppPlayAudioIcon } from "../../../assets/icons";


export default function MessageAudioPlayer(props: MessageAudioPlayerProps) {

  const { url, isInbound, customerName } = props;

  const classes = useStyles();
  const elementOrder: ('player' | 'avatar')[] = isInbound ? ['player', 'avatar'] : ['avatar', 'player'];

  const accountSettings = useAppSelector(selectAccountSettings);

  const containerRef = useRef<any>();

  const [currentTimeDisplayed, setCurrentTimeDisplayed] = useState<string>('0:00');
  const [maxTimeDisplayed, setMaxTimeDisplayed] = useState<string>('0:00');

  const { wavesurfer, isReady, isPlaying, currentTime } = useWavesurfer({
    container: containerRef,
    url: url,
    normalize: true,
    hideScrollbar: true,

    width: 160,
    height: 25,

    waveColor: Color.gray2,
    progressColor: Color.clear1,

    barWidth: 3,
    barGap: 1,
    barRadius: 4,

    cursorWidth: 15,
  })

  useEffect(() => {
    if (isReady) {
      setMaxTimeDisplayed(secondsToDisplayedTime(wavesurfer!.getDuration()))
    }
  }, [isReady])

  useEffect(() => {
    setCurrentTimeDisplayed(secondsToDisplayedTime(currentTime))
  }, [currentTime])

  function onPlayPause() {
    wavesurfer && wavesurfer.playPause()
  }

  function padLeft(str: number, pad: string, length: number) {
    return (new Array(length+1).join(pad)+str).slice(-length);
  }

  function secondsToDisplayedTime(durationInSeconds: number) {
    const minutes = Math.floor(durationInSeconds / 60);
    const seconds = Math.floor(durationInSeconds - minutes * 60);
    const timeToDisplay = padLeft(minutes,'0',1) + ':' + padLeft(seconds,'0',2);
    return timeToDisplay;
  }

  function getInitials() {
    if (!customerName) return '';

    const splitFullName = customerName.split(' ');
    if (splitFullName.length === 1) {
      return `${splitFullName[0][0]}${splitFullName[0][1]}`
    }
    return `${splitFullName[0][0]}${splitFullName[1][0]}`;
  }
  
  function mapElement(element: 'player' | 'avatar') {
    switch (element) {
      case "player":
        return (
          <>
            <div
              onClick={onPlayPause}
            >
              <WhatsAppPlayAudioIcon />
            </div>

            <div id="waveform" ref={containerRef} />
          </>
        );
      case "avatar":
        return (
          <div
            className={`${classes.avatarContainer} ${isInbound && classes.avatarWithInitials}`}
          >
            {isInbound
              ? <span className={classes.avatarInitials}>{getInitials()}</span>
              : accountSettings.accountLogo && accountSettings.accountLogo !== ""
                ? <img alt={'logo'} className={classes.accountLogo} src={accountSettings.accountLogo} />
                : <WhatsAppAudioLogo />
            }
            <div className={classes.avatarMicrophone} style={isInbound ? { left: -5 } : { right: -5 }}>
              <WhatsAppMicrophoneIcon />
            </div>
          </div>
        )
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        {
          elementOrder.map(mapElement)
        }
      </div>
      <span className={classes.duration} style={{ left: isInbound ? 60 : 115 }}>{currentTime === 0 ? maxTimeDisplayed : currentTimeDisplayed}</span>
    </div>
  );
}